const openMobileFilterNav = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';

  $('html').addClass(`mobile-${prefix}filter-nav-opened`);
  $('[data-full-overlay]').addClass('active').addClass('white');
};

const closeMobileFilterNav = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';

  $('html').removeClass(`mobile-${prefix}filter-nav-opened`);
  $('[data-full-overlay]').removeClass('active').removeClass('white');
};

const initMobileFilterNav = () => {
  // const from_search = document.body.classList.contains('has-overlay-search');
  // const prefix = (from_search) ? 'overlay-search-' : '';

  $(document).on('click touchend', '[data-show-mobile-filter-nav]', (e) => {
    e.stopPropagation();
    e.preventDefault();
    const prefix = ($('[data-overlay-search]').hasClass('opened')) ? 'overlay-search-' : '';

    ($(`.mobile-${prefix}filter-nav-opened`).length) ? closeMobileFilterNav() : openMobileFilterNav();
  });

  $(document).on('click touchend', '[data-mobile-filter-nav-close]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    closeMobileFilterNav();
  });

  $(document).on('click touchend', '[data-sorting-close-mobile]', (e) => {
    const $item = $(e.currentTarget);
    $item.closest('.filter-button-mobile-container').find('[data-show-mobile-sorting-nav]').trigger('click');
  });

  $(document).on('click touchend', '[data-show-mobile-sorting-nav]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = (from_search) ? 'overlay-search-' : '';
    $(`[data-mobile-${prefix}filter-sorting]`).toggleClass('active');
    $(`[data-sorting-close-mobile`).toggleClass('active');
  });
};

export {
  initMobileFilterNav,
  closeMobileFilterNav,
};
